<template>
	<div>
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" :layout="layout" :total="total">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: 'Pagination',
		props: {
			total: {
				required: true,
				type: Number
			},
			page: {
				type: Number,
				default: 1
			},
			limit: {
				type: Number,
				default: 20
			},
			pageSizes: {
				type: Array,
				default () {
					return [10, 20, 30, 50, 100, 500, 1000]
				}
			},
			layout: {
				type: String,
				default: 'total, sizes, prev, pager, next, jumper'
			}

		},
		computed: {
			currentPage: {
				get() {
					return this.page
				},
				set(val) {
					this.$emit('update:page', val)
				}
			},
			pageSize: {
				get() {
					return this.limit
				},
				set(val) {
					this.$emit('update:limit', val)
				}
			}
		},
		data() {
			return {

			}
		},
		methods: {
			handleSizeChange(num) {
				this.$emit('on-pagination', {
					page: this.currentPage,
					limit: num
				})

			},
			handleCurrentChange(currentPage) {
				//console.log("当前第几页" + currentPage);
				this.$emit('on-pagination', {
					page: currentPage,
					limit: this.pageSize
				})

			},
		}
	}
</script>

<style>
</style>
